package net.lateinit.bug_or_feature.site.util

import kotlinx.browser.window

fun shareLink(id: String?) {
    val url = if (id.isNullOrBlank()) {
        "${window.location.origin}/"
    } else {
        "${window.location.origin}/q/$id"
    }
    
    // 클립보드에 복사
    window.navigator.clipboard.writeText(url).then {
        console.log("Link copied: $url")
    }.catch {
        console.error("Failed to copy link", it)
    }
}
